import { map, orderBy } from 'lodash';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, NavbarBrand, NavbarText, Table } from 'reactstrap';
import { gql, useQuery } from 'urql';
import { CenteredContainer } from '.';
import { HacpackQuery, HacpackQueryTerminalArguments, Terminal } from '../types/graph';
import { useCurrentUser } from '../hooks';
import styled from '../themes/themed-styled-components';
import { GraphDeepPartialNotListed, GraphDeepPartialOverride } from '../types';
import DateTime from './DateTime';
import Loading from './Loading';
import LoadingUnitIdentifier from './LoadingUnitIdentifier';
import { Link } from 'react-router-dom';


type TerminalSegregationQueryData = GraphDeepPartialOverride<HacpackQuery, {
    terminal: TerminalSegregationTerminal
}>
type TerminalSegregationTerminal = GraphDeepPartialNotListed<Terminal, 'id' | 'name' | 'slug' | 'port' | 'segregations'>

type TerminalSegregationQueryArguments = HacpackQueryTerminalArguments;

const terminalSegregationQuery = gql<TerminalSegregationQueryData, TerminalSegregationQueryArguments>`
query terminal($id: Int!) {
    terminal (id: $id) {
        id
        name
        slug
        port
        segregations {
            id
            loadingUnit1Identifier
            loadingUnit2Identifier
            class1
            class2
            row1
            row2
            bay1
            bay2
            area
            terminalName
            dateOfInput
        }
    }
}`;

const StyledTable = styled(Table)`
    margin-bottom: 0;
    & th, & td {
        vertical-align: middle;
    }
    tbody {
        tr:nth-child(4n+1),
        tr:nth-child(4n+2) {
            td[rowspan="2"],
            th[rowspan="2"] {
               background-color: rgba(0,0,0,.05);
            }
        }
        tr:nth-child(2n) td:not([rowspan]) {
           background-color: rgba(0,0,0,.05);
        }
    }
`;

type TerminalSegregationProps = {
    id: number
}

const TerminalSegregation = ({ id }: TerminalSegregationProps) => {

    const { t } = useTranslation('common');
    const { isSuperuser } = useCurrentUser();

    const [result] = useQuery<TerminalSegregationQueryData, TerminalSegregationQueryArguments>({
        query: terminalSegregationQuery,
        variables: { id }
    });

    const { data/*, fetching, error*/ } = result;

    const terminal = data?.terminal;

    const segregations = terminal?.segregations;

    if (segregations === undefined) {
        return <Loading />
    }

    if (segregations.length === 0) {
        return <CenteredContainer>{t('Nessun errore di segregazione')}</CenteredContainer>
    }

    return <>
        <Navbar className="navbar ng-white border-bottom box-shadow" light>
            <div>
                <NavbarBrand>{t('Segregazione')}</NavbarBrand>
                <NavbarText>{t('Errori')}</NavbarText>
            </div>
            <div className="d-sm-inline-flex flex-sm-row">

            </div>
            <div className="navbar-right d-sm-inline-flex flex-sm-row">

            </div>
        </Navbar>

        <StyledTable className="table-sm">
            <thead>
                <tr>
                    {isSuperuser ? <th>{t('ID')}</th> : null}
                    <th>{t('Unità di carico')}</th>
                    <th>{t('Classe')}</th>
                    <th>{t('Area')}</th>
                    <th>{t('Baia')}</th>
                    <th>{t('Fila')}</th>
                    <th>{t('Data d\'inserimento')}</th>
                </tr>
            </thead>
            <tbody>
                {map(orderBy(segregations,['dateOfInput','desc']), (segregation) =>
                    <Fragment key={segregation.id}>
                        <tr>
                            {isSuperuser ? <th rowSpan={2}>{segregation.id}</th> : null}
                            <td><Link onClick={ev => ev.stopPropagation()} to={`unita-in-sosta/${segregation.loadingUnit1Identifier!.toLowerCase()}/segregazione`}><LoadingUnitIdentifier identifier={segregation.loadingUnit1Identifier} /></Link></td>
                            <td>{segregation.class1}</td>
                            <td rowSpan={2}>{segregation.area}</td>
                            <td>{segregation.bay1}</td>
                            <td>{segregation.row1}</td>
                            <td rowSpan={2}><DateTime date={segregation.dateOfInput} /></td>
                        </tr>
                        <tr>
                            {/*spanned*/}

                            <td><Link onClick={ev => ev.stopPropagation()} to={`unita-in-sosta/${segregation.loadingUnit2Identifier!.toLowerCase()}/segregazione`}><LoadingUnitIdentifier identifier={segregation.loadingUnit2Identifier} /></Link></td>
                            <td>{segregation.class2}</td>
                            {/*spanned*/}
                            <td>{segregation.bay2}</td>
                            <td>{segregation.row2}</td>
                            {/*spanned*/}
                        </tr>
                    </Fragment>
                )}
            </tbody>
        </StyledTable>
    </>;
}

export default TerminalSegregation;